import { StyleSheet, View } from 'react-native'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Timeslot from 'components/molecules/Timeslot'
import React from 'react'

const PreviewTimeslotKind = ({ timeslotKind, ...props }) => {
	
	const fakeBooking = {
		timeslotKind,
		timeslot: {
			timeslot_start: '09:00',
			timeslot_end: '18:00',
			capacity: 20
		}
	};
	
	return (
		<View
			style={ styles.container }>
			
			<View
				style={ styles.view }>
				
				<ThemedBlock
					shadow>
					
					<Timeslot
						item={ fakeBooking }
						itemProps={{
							showCapacity: true
						}}
						timeslotKind={ timeslotKind }
						timeslotIconOverWriteProperties={ timeslotKind }
					/>
				</ThemedBlock>
			</View>
		</View>
	)
}

const styles = StyleSheet.create( {
	container: {
		alignItems: 'center'
	},
	view: {
		width: '100%',
		maxWidth: 400
	}
})

export default PreviewTimeslotKind
